module.exports = __webpack_public_path__ + "img/img-12.2db2b782.png";